// ©2024 Austin App House. All rights reserved.
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { MDBModal, MDBModalBody } from 'mdbreact';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import Select from '../../../components/layout/CustomSelect';
import { connect } from 'react-redux';
import { white as customSelectStyle } from '../../../utils/customSelectStyle';
import { workOrderTypes } from '../../../utils/constans';
import { toggleModal } from '../../../storage/actions/modalsActions';
import { setFiltersObject } from '../../../storage/actions/workOrdersActions';
import getWorkOrderStatusSet from '../../../utils/getWorkOrderStatusSet';
import getTemplatesList from '../../../utils/api/get/getTemplatesList';
import CustomFieldFiltersSection from '../../layout/filters/CustomFieldFiltersSection';
import getClientsList from '../../../utils/api/get/getClientsList';
import FiltersModalShell from './FiltersModalShell';

class ModalWOFilters extends React.Component {
  constructor(props) {
    super(props);
    const filters = props.filters || {};
    const selectedWOTypes = getWorkOrderStatusSet(
      filters.selectedWOTypes,
      filters.needFilterByRouterStatus,
      filters.needFilterWithoutRouterStatus,
    );
    this.state = {
      form: {
        winNumbers: filters.winNumbers || '',
        contractorId: filters.contractorId || '',
        startDate: filters.startDate || {},
        endDate: filters.endDate || {},
        selectProject: filters.selectProject || [],
        selectCompany: filters.selectCompany || '',
        workOrderId: filters.workOrderId || '',
        workOrderTitle: filters.workOrderTitle || '',
        selectedWOTypes,
        filterByStatusOnHold: filters.filterByStatusOnHold || '',
        cityName: filters.cityName || '',
        selectState: filters.selectState || '',
        zipCode: filters.zipCode || '',
        selectCountry: filters.selectCountry || '',
        siteId: filters.siteId || '',
        siteName: filters.siteName || '',
        payRate: filters.payRate || {},
        createdDate: filters.createdDate || {},
        assignedDate: filters.assignedDate || {},
        completedDate: filters.completedDate || {},
        approvedDate: filters.approvedDate || {},
        paidDate: filters.paidDate || {},
        selectedCustomFields: new Set(filters.selectedCustomFields || []),
        selectedWorkTypes: new Set(filters.selectedWorkTypes || []),
        selectedTemplates: new Set(filters.selectedTemplates || []),
        payLocation: filters.payLocation || '',
        selectedClients: []
      },
      projects: [],
      clients: [],
      workOrderTypes,
      stateArray: [],
      countries: [],
      rateTypes: [
        {
          value: 'Hour',
          label: 'Hour',
        },
        {
          value: 'Device',
          label: 'Device',
        },
        {
          value: 'Site',
          label: 'Site / Flat',
        },
      ],
      customFields: [],
      workTypes: [],
      templates: [],
      payLocations: [
        {
          value: 'all',
          label: 'All',
        },
        {
          value: 'payOutsideOfApp',
          label: 'Pay outside app',
        },
        {
          value: 'payWithinApp',
          label: 'Pay within app',
        },
      ],
    };
  }

  // eslint-disable-next-line react/sort-comp
  resetFilters = () => {
    this.setState({
      form: {
        winNumbers: '',
        contractorId: '',
        startDate: {},
        endDate: {},
        selectedClients: [],
        selectProject: [],
        filterByStatusOnHold: '',
        selectCompany: '',
        workOrderId: '',
        workOrderTitle: '',
        selectedWOTypes: new Set(),
        cityName: '',
        selectState: '',
        zipCode: '',
        selectCountry: '',
        siteId: '',
        siteName: '',
        payRate: {},
        createdDate: {},
        assignedDate: {},
        completedDate: {},
        approvedDate: {},
        paidDate: {},
        selectedCustomFields: new Set(),
        selectedWorkTypes: new Set(),
        selectedTemplates: new Set(),
        payLocation: '',
      },
    });
  }

  handlerOnChange = ({ name, value }) => {
    this.setState(
      cur => ({ form: { ...cur.form, [name]: value || '' } }),
      () => {
        if (name === 'selectCountry') this.getStates();
      },
    );
  }

  handlerSetChanges = ({ target }) => {
    const newSet = new Set([...this.state.form[target.name]]);
    const command = target.checked ? 'add' : 'delete';
    newSet[command](target.value);
    this.setState(cur => ({ form: { ...cur.form, [target.name]: newSet } }));
  }

  handlerObjectChanges = (field, name, value) => {
    this.setState(cur => ({
      form: { ...cur.form, [field]: { ...cur.form[field], [name]: value || '' } },
    }));
  }

  closeModal = () => this.props.toggleModal(false, 'filtersModal');

  handlerAccept = event => {
    event.preventDefault();
    const filters = this.getFilters();
    this.props.getFilters(filters);
    this.closeModal();
  }

  getFilters = () => {
    const fields = Object.keys(this.state.form);
    if (!fields.length) return null;
    const result = {};
    fields
      .filter(key => (
        this.state.form[key] !== ''
        && (
          !(this.state.form[key] instanceof Set)
          || this.state.form[key].size > 0
        )
        && (
          !(this.state.form[key] instanceof Object)
          || (this.state.form[key] instanceof Set)
          || (this.state.form[key] instanceof Date)
          || this.state.form[key].from
          || this.state.form[key].to
          || this.state.form[key].value
          || this.state.form[key].length
        )
      ))
      // eslint-disable-next-line consistent-return
      .forEach(key => {
        if (this.state.form[key] instanceof Set) {
          const newSet = new Set([...this.state.form[key]]);
          if (key === 'selectedWOTypes' && newSet.has('routed')) {
            result.needFilterByRouterStatus = {
              published: newSet.has('published'),
              draft: newSet.has('draft'),
            };
            newSet.add('published');
            newSet.add('draft');
          }
          if (
            key === 'selectedWOTypes'
            && !newSet.has('routed')
            && (newSet.has('published') || newSet.has('draft'))
          ) result.needFilterWithoutRouterStatus = true;
          newSet.delete('routed');
          result[key] = [...newSet];
          return;
        }
        if (this.state.form[key] instanceof Date) {
          const newDate = {};
          newDate.from = this.state.form[key];
          newDate.to = new Date(new Date(this.state.form[key]).setHours(24, 0, 0, -1));
          result[key] = newDate;
          return;
        }
        result[key] = this.state.form[key];
      });
    return result;
  }

  getCountries = () => {
    axios.get('/api/address/getAllCountries')
      .then(res => {
        if (res.data.length && res.data.length > 0) {
          return this.setState({
            countries: res.data.map(item => ({
              ...item,
              label: item.name,
              value: item.isoCode,
            })),
          }, this.getStates);
        }
        throw new Error('Can\'t get list of countries!');
      })
      .catch(error => {
        console.error(error);
      });
  }

  getStates = () => {
    axios.get('/api/address/getStatesOfCountry', {
      params: {
        countryId: this.state?.form?.selectCountry?.value || '',
      },
    })
      .then(res => {
        this.setState({
          stateArray: res.data?.payload?.states || [],
        });
      })
      .catch(error => {
        console.error(error);
      });
  }

  getWorkTypes = () => {
    axios.get('/api/users/getTools')
      .then(res => {
        if (res.data.Tools && res.data.Tools.length > 0) {
          return this.setState({ workTypes: res.data.Tools });
        }
        throw new Error('Can\'t get list of work types!');
      })
      .catch(error => {
        console.error(error);
      });
  }

  getProjects = () => {
    axios.get('/api/projects')
      .then(res => {
        if (res.data?.payload?.data?.length) {
          return this.setState({
            projects: res.data.payload.data.map(item => ({
              label: item.name,
              value: item._id,
            })),
          });
        }
        throw new Error('Can\'t get list of projects!');
      })
      .catch(error => {
        console.error(error);
      });
  }

  getWOCompanies = () => {
    axios.get('/api/wo-companies')
      .then(res => {
        if (res.data?.payload?.data?.length) {
          return this.setState({
            woCompanies: res.data.payload.data.map(item => ({
              label: item.name,
              value: item._id,
            })),
          });
        }
        throw new Error('Can\'t get list of companies!');
      })
      .catch(error => {
        console.error(error);
      });
  }

  getCustomFields = () => {
    axios.get('/api/client/custom_fields')
      .then(res => {
        if (!res.data?.payload?.customFields) throw new Error('Can\'t get list of custom field(s)!');
        const { customFields } = res.data.payload;
        this.setState({ customFields });
      })
      .catch(error => {
        console.error(error);
      });
  }

  getTemplates = () => {
    getTemplatesList()
      .then(newTemplatesList => {
        this.setState({ templates: newTemplatesList });
      })
      .catch(error => {
        console.error(error);
      });
  }

  getClients = () => {
    getClientsList()
      .then(clients => {
        this.setState({
          clients: clients.map(item => ({ label: item.name, value: item.userId }))
        });
      })
      .catch(error => {
        console.error(error);
      });
  }

  componentDidMount() {
    this.getCountries();
    this.getWorkTypes();
    this.getProjects();
    this.getWOCompanies();
    this.getCustomFields();
    this.getTemplates();
    this.getClients()
  }

  render() {
    const { isOpen } = this.props;
    const {
      projects,
      woCompanies,
      workOrderTypes,
      stateArray, countries,
      rateTypes,
      customFields,
      workTypes,
      payLocations,
      templates,
      clients
    } = this.state;
    const {
      winNumbers,
      contractorId,
      startDate,
      endDate,
      selectProject,
      selectCompany,
      workOrderId,
      workOrderTitle,
      selectedWOTypes,
      cityName,
      selectState,
      zipCode,
      selectCountry,
      siteId,
      siteName,
      payRate,
      createdDate,
      assignedDate,
      completedDate,
      approvedDate,
      paidDate,
      selectedCustomFields,
      selectedWorkTypes,
      selectedClients,
      filterByStatusOnHold,
      selectedTemplates,
      payLocation,
    } = this.state.form;
    const currentFilters = this.getFilters() || {};
    const activeFiltersCount = Object.keys(currentFilters).length;

    return (
      <FiltersModalShell
        title={`Filter (${activeFiltersCount})`}
        onClose={this.closeModal}
        footer={(
          <>
            <button
              type="button"
              className="dashboard-btn dashboard-btn--secondary"
              onClick={this.resetFilters}
            >
              Reset Filters
            </button>
            <button
              type="button"
              className="dashboard-btn dashboard-btn--primary"
              onClick={this.handlerAccept}
            >
              Accept
            </button>
          </>
        )}
      >
                <div className="field_row textarea_row">
                  <div className="field_name">
                    <label htmlFor="winNumbers">WIN#</label>
                  </div>
                  <div className="field_block">
                    <textarea
                      id="winNumbers"
                      className="width-inherit"
                      style={{ fontSize: '11px' }}
                      rows="5"
                      name="winNumbers"
                      placeholder="
              Format WIN's as:&#13;&#10;
              1000117&#13;&#10;
              11000126&#13;&#10;
              11000140&#13;&#10;
              11000141&#13;&#10;
              11000142&#13;&#10;
              11000143&#13;&#10;
              11000146&#13;&#10;
              11000151&#13;&#10;
              11000259"
                      value={winNumbers}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="contractorId">Contractor ID</label>
                  </div>
                  <div className="field_block">
                    <input
                      id="contractorId"
                      type="text"
                      name="contractorId"
                      className="input-field"
                      placeholder="Type contractor id"
                      value={contractorId}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>

                <div className="field_row date_row">
                  <div className="field_name">
                    <span>Start Date</span>
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="startDateFrom"
                      selected={startDate.from}
                      onChange={date => this.handlerObjectChanges('startDate', 'from', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="From"
                    />
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="startDateTo"
                      selected={startDate.to}
                      onChange={date => this.handlerObjectChanges('startDate', 'to', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="To"
                    />
                  </div>
                </div>

                <div className="field_row date_row">
                  <div className="field_name">
                    <span>End Date</span>
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="endDateFrom"
                      selected={endDate.from}
                      onChange={date => this.handlerObjectChanges('endDate', 'from', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="From"
                    />
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="endDateTo"
                      selected={endDate.to}
                      onChange={date => this.handlerObjectChanges('endDate', 'to', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="To"
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="createdBy">Created by</label>
                  </div>
                  <div className="field_block">
                    <Select
                      inputId="createdBy"
                      isClearable
                      isSearchable
                      isMulti
                      options={clients}
                      value={[...selectedClients]}
                      styles={customSelectStyle}
                      onChange={value => this.handlerOnChange({ name: 'selectedClients', value: new Set(value || []) })}
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="companySelect">Company</label>
                  </div>
                  <div className="field_block">
                    <Select
                      inputId="companySelect"
                      isClearable
                      isSearchable
                      options={woCompanies}
                      value={selectCompany}
                      styles={customSelectStyle}
                      onChange={value => this.handlerOnChange({ name: 'selectCompany', value })}
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="projectSelect">Project</label>
                  </div>
                  <div className="field_block">
                    <Select
                      inputId="projectSelect"
                      isClearable
                      isSearchable
                      isMulti
                      options={projects}
                      value={[...selectProject]}
                      styles={customSelectStyle}
                      onChange={value => this.handlerOnChange({ name: 'selectProject', value: new Set(value || []) })}
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="workOrderId">Company WO ID</label>
                  </div>
                  <div className="field_block">
                    <input
                      id="workOrderId"
                      type="text"
                      name="workOrderId"
                      className="input-field"
                      placeholder="Type Company WO ID"
                      value={workOrderId}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="workOrderTitle">WO Title</label>
                  </div>
                  <div className="field_block">
                    <input
                      id="workOrderTitle"
                      type="text"
                      name="workOrderTitle"
                      className="input-field"
                      placeholder="Type work order title"
                      value={workOrderTitle}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>

                  <div className="field_row">
                      <div className="field_name">
                          <label htmlFor="woStatus">WO Status</label>
                      </div>
                      <div className="field_block">
                          <Select
                              inputId="woStatus"
                              isClearable
                              isSearchable
                              options={workOrderTypes.map(item => ({
                                  value: item.value,
                                  label: item.title,
                              }))}
                              value={
                                  selectedWOTypes.size > 0
                                      ? [...selectedWOTypes].map(value => ({
                                          value,
                                          label: workOrderTypes.find(w => w.value === value)?.title || value,
                                      }))[0]
                                      : null
                              }
                              styles={customSelectStyle}
                              onChange={option => {
                                  const newSet = new Set();
                                  if (option) newSet.add(option.value);
                                  this.handlerOnChange({ name: 'selectedWOTypes', value: newSet });
                              }}
                          />
                      </div>
                  </div>

                  <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="cityName">City</label>
                  </div>
                  <div className="field_block">
                    <input
                      id="cityName"
                      type="text"
                      name="cityName"
                      className="input-field"
                      placeholder="Type city name"
                      value={cityName}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="stateSelect">State</label>
                  </div>
                  <div className="field_block">
                    <Select
                      inputId="stateSelect"
                      isClearable
                      isSearchable
                      options={stateArray}
                      value={selectState}
                      styles={customSelectStyle}
                      onChange={value => this.handlerOnChange({ name: 'selectState', value })}
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="zipCode">Zip</label>
                  </div>
                  <div className="field_block">
                    <input
                      id="zipCode"
                      type="text"
                      name="zipCode"
                      className="input-field"
                      placeholder="Type zip code"
                      value={zipCode}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="countrySelect">Country</label>
                  </div>
                  <div className="field_block">
                    <Select
                      inputId="countrySelect"
                      isClearable
                      options={countries}
                      value={selectCountry}
                      styles={customSelectStyle}
                      onChange={value => this.handlerOnChange({ name: 'selectCountry', value })}
                    />
                  </div>
                </div>

                <div className="field_row textarea_row">
                  <div className="field_name">
                    <label htmlFor="siteId">Site ID</label>
                  </div>
                  <div className="field_block">
                    <textarea
                      id="siteId"
                      className="width-inherit"
                      style={{ fontSize: '11px' }}
                      rows="5"
                      name="siteId"
                      placeholder="
              Format Site ID's as:&#13;&#10;
              Site Id 1&#13;&#10;
              Site Id 2&#13;&#10;
              Site Id 3&#13;&#10;
              Site Id 4&#13;&#10;
              Site Id 5&#13;&#10;
              Site Id 6"
                      value={siteId}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="siteName">Site Name</label>
                  </div>
                  <div className="field_block">
                    <input
                      id="siteName"
                      type="text"
                      name="siteName"
                      className="input-field"
                      placeholder="Type site name"
                      value={siteName}
                      onChange={event => this.handlerOnChange(event.target)}
                    />
                  </div>
                </div>

                <div className="field_row payrate_row">
                  <div className="field_name">
                    <span>Pay Rate</span>
                  </div>
                  <div className="field_block">
                    <input
                      type="text"
                      name="payRateFrom"
                      className="input-field"
                      placeholder="From"
                      value={payRate.from}
                      onChange={event => this.handlerObjectChanges('payRate', 'from', parseFloat(event.target.value) || 0)}
                    />
                  </div>
                  <span className="delimiter">-</span>
                  <div className="field_block">
                    <input
                      type="text"
                      name="payRateTo"
                      className="input-field"
                      placeholder="To"
                      value={payRate.to}
                      onChange={event => this.handlerObjectChanges('payRate', 'to', parseFloat(event.target.value) || 0)}
                    />
                  </div>
                  <span className="delimiter">per</span>
                  <div className="field_block">
                    <Select
                      isClearable
                      options={rateTypes}
                      value={payRate.type}
                      styles={customSelectStyle}
                      onChange={value => this.handlerObjectChanges('payRate', 'type', value)}
                    />
                  </div>
                </div>

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="payLocation">Payment Location</label>
                  </div>
                  <div className="field_block">
                    <Select
                      inputId="payLocation"
                      options={payLocations}
                      value={payLocation}
                      styles={customSelectStyle}
                      onChange={value => this.handlerOnChange({ name: 'payLocation', value })}
                    />
                  </div>
                </div>

                <div className="field_row date_row">
                  <div className="field_name">
                    <span>Date Created</span>
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="createdDateFrom"
                      selected={createdDate.from}
                      onChange={date => this.handlerObjectChanges('createdDate', 'from', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="From"
                    />
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="createdDateTo"
                      selected={createdDate.to}
                      onChange={date => this.handlerObjectChanges('createdDate', 'to', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="To"
                    />
                  </div>
                </div>

                <div className="field_row date_row">
                  <div className="field_name">
                    <span>Date Assigned</span>
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="assignedDateFrom"
                      selected={assignedDate.from}
                      onChange={date => this.handlerObjectChanges('assignedDate', 'from', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="From"
                    />
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="assignedDateTo"
                      selected={assignedDate.to}
                      onChange={date => this.handlerObjectChanges('assignedDate', 'to', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="To"
                    />
                  </div>
                </div>

                <div className="field_row date_row">
                  <div className="field_name">
                    <span>Date Completed</span>
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="completedDateFrom"
                      selected={completedDate.from}
                      onChange={date => this.handlerObjectChanges('completedDate', 'from', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="From"
                    />
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="completedDateTo"
                      selected={completedDate.to}
                      onChange={date => this.handlerObjectChanges('completedDate', 'to', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="To"
                    />
                  </div>
                </div>

                <div className="field_row date_row">
                  <div className="field_name">
                    <span>Date Approved</span>
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="approvedDateFrom"
                      selected={approvedDate.from}
                      onChange={date => this.handlerObjectChanges('approvedDate', 'from', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="From"
                    />
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="approvedDateTo"
                      selected={approvedDate.to}
                      onChange={date => this.handlerObjectChanges('approvedDate', 'to', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="To"
                    />
                  </div>
                </div>

                <div className="field_row date_row">
                  <div className="field_name">
                    <span>Date Paid</span>
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="paidDateFrom"
                      selected={paidDate.from}
                      onChange={date => this.handlerObjectChanges('paidDate', 'from', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="From"
                    />
                  </div>
                  <div className="field_block">
                    <DatePicker
                      className="input-field"
                      name="paidDateTo"
                      selected={paidDate.to}
                      onChange={date => this.handlerObjectChanges('paidDate', 'to', date)}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="To"
                    />
                  </div>
                </div>

                <CustomFieldFiltersSection
                  customFields={customFields}
                  selectCustomField={value => this.handlerOnChange({ name: 'selectedCustomFields', value: new Set(value || []) })}
                  selectedCustomFields={[...selectedCustomFields]}
                />

                <div className="field_row">
                  <div className="field_name">
                    <label htmlFor="templatesSelect">Template(s)</label>
                  </div>
                  <div className="field_block">
                    <Select
                      inputId="templatesSelect"
                      isClearable
                      isSearchable
                      isMulti
                      closeMenuOnSelect={false}
                      options={templates}
                      value={[...selectedTemplates]}
                      styles={customSelectStyle}
                      onChange={value => this.handlerOnChange({ name: 'selectedTemplates', value: new Set(value || []) })}
                    />
                  </div>
                </div>

                <div className="field_row checkbox_row">
                  <div className="field_name">
                    <span>Type(s) of work</span>
                  </div>
                  <div className="field_block checkbox_group">
                    {
                      workTypes && workTypes.map(workType => (
                        <label key={workType} className="check_btn">
                          <input
                            type="checkbox"
                            id={workType}
                            value={workType}
                            name="selectedWorkTypes"
                            checked={selectedWorkTypes.has(workType)}
                            onChange={this.handlerSetChanges}
                          />
                          <span>{workType}</span>
                        </label>
                      ))
                    }
                  </div>
                </div>
      </FiltersModalShell>
    );
  }
}

const mapDispatchToProps = {
  toggleModal,
  getFilters: setFiltersObject,
};

const mapStateToProps = state => ({
  isOpen: state.modalState?.filtersModal?.isOpen,
  filters: state?.workOrder?.filters,
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalWOFilters);
